import { sortDuckCreator } from 'axl-ducks';
import { pageNames } from '@atc/bonnet-paths';

export default sortDuckCreator({
    namespace: pageNames.DEALER_SEARCH,
    storePrefix: `${pageNames.DEALER_SEARCH}.`,
});
